import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect, useSelector } from 'react-redux'
import {
	Form,
	Switch,
	Input,
	Card,
	Button,
	Space,
	Typography,
	Divider,
	Row,
	Col,
	Select,
	InputNumber,
	Collapse,
} from 'antd'
import { SaveOutlined } from '@ant-design/icons'
import { listTemplate } from '~/states/modules/templates'

const { Title } = Typography
const { Option } = Select
const { Panel } = Collapse

const Columns = ({ config, onSave, templates, loadTemplates }) => {
	const { is_admin } = useSelector(({ session }) => session)
	const [form] = Form.useForm()
	const [loading, setLoading] = useState(false)

	useEffect(() => {
		if (config) {
			form.setFieldsValue({
				primary_color: config.primary_color || '#830AD1',
				use_contracts: Boolean(config.use_contracts),
				has_demands: Boolean(config.has_demands),
				has_document_dashboard: Boolean(config.has_document_dashboard),
				document_columns: config.document_columns || [],
				period_configs: config.period_configs || [],
				notification_emails: config.notification_emails || [],
			})
		}
	}, [config, form])

	useEffect(() => {
		loadTemplates()
	}, [loadTemplates])

	const onFinish = async (values) => {
		setLoading(true)
		try {
			await onSave({
				primary_color: values.primary_color,
				use_contracts: values.use_contracts,
				has_demands: values.has_demands,
				has_document_dashboard: Boolean(values.has_document_dashboard),
				document_columns: values.document_columns,
				period_configs: values.period_configs,
				notification_emails: values.notification_emails,
			})
		} catch (error) {
			console.error('Error:', error)
		} finally {
			setLoading(false)
		}
	}
	return (
		<Form
			form={form}
			layout="inline"
			onFinish={onFinish}
			style={{ marginTop: 24 }}>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					marginBottom: 24,
					width: '100%',
				}}>
				<Title level={4} style={{ margin: 0 }}>
					Colunas
				</Title>
				<Button
					type="primary"
					htmlType="submit"
					icon={<SaveOutlined />}
					loading={loading}>
					Salvar Configurações
				</Button>
			</div>

			<Row gutter={[16, 16]} style={{ width: '100%' }}>
				<Col xs={24} sm={24} md={12} lg={12} xl={12}>
					<Card>
						<Space direction="vertical" style={{ width: '100%' }}>
							<Title level={4}>Cor Primária</Title>
							<Form.Item
								name="primary_color"
								label="Cor Primária"
								style={{ marginBottom: 24, width: '100%' }}>
								<Input type="color" />
							</Form.Item>
						</Space>
					</Card>
				</Col>
				<Col xs={24} sm={24} md={12} lg={12} xl={12}>
					<Card>
						<Space direction="vertical" style={{ width: '100%' }}>
							<Title level={4}>Configuração de Contratos</Title>
							<Form.Item
								name="use_contracts"
								label="Usar Contratos"
								valuePropName="checked"
								style={{ marginBottom: 24, width: '100%' }}>
								<Switch size="small" />
							</Form.Item>
						</Space>
					</Card>
				</Col>
			</Row>

			{is_admin && (
				<Row gutter={[16, 16]} style={{ width: '100%', marginTop: 16 }}>
					<Col xs={24} sm={24} md={12} lg={12} xl={12}>
						<Card>
							<Space direction="vertical" style={{ width: '100%' }}>
								<Title level={4}>Configuração de Demandas</Title>
								<Form.Item
									name="has_demands"
									label="Possui portal de demandas"
									valuePropName="checked"
									style={{ marginBottom: 24, width: '100%' }}>
									<Switch size="small" />
								</Form.Item>
							</Space>
						</Card>
					</Col>
					<Col xs={24} sm={24} md={12} lg={12} xl={12}>
						<Card>
							<Space direction="vertical" style={{ width: '100%' }}>
								<Title level={4}>Dashboard de Documentos</Title>
								<Form.Item
									name="has_document_dashboard"
									label="Possui dashboard de documentos"
									valuePropName="checked"
									style={{ marginBottom: 24, width: '100%' }}>
									<Switch size="small" />
								</Form.Item>
							</Space>
						</Card>
					</Col>
				</Row>
			)}

			<Divider style={{ margin: '32px 0' }} />

			<Collapse style={{ width: '100%' }}>
				<Panel header="Colunas da listagem de documentos" key="columns">
					<Form.List name="document_columns">
						{(fields) => (
							<Row gutter={[16, 16]}>
								{fields.map(({ key, name, ...restField }) => (
									<Col xs={24} sm={24} md={12} lg={8} xl={6} key={key}>
										<Card>
											<Space direction="vertical" style={{ width: '100%' }}>
												<Form.Item
													{...restField}
													name={[name, 'display_name']}
													label="Nome de Exibição"
													style={{ marginBottom: 24, width: '100%' }}>
													<Input />
												</Form.Item>
												<Form.Item
													{...restField}
													name={[name, 'name']}
													label="Nome do Campo"
													style={{ marginBottom: 24, width: '100%' }}>
													<Input disabled />
												</Form.Item>
												<Form.Item
													{...restField}
													name={[name, 'sort_name']}
													label="Nome para Ordenação"
													style={{ marginBottom: 24, width: '100%' }}>
													<Input />
												</Form.Item>
												<Row gutter={16}>
													<Col span={12}>
														<Form.Item
															{...restField}
															name={[name, 'is_active']}
															label="Ativo"
															valuePropName="checked"
															colon={false}
															style={{ marginBottom: 0, width: '100%' }}>
															<Switch size="small" />
														</Form.Item>
													</Col>
													<Col span={12}>
														<Form.Item
															{...restField}
															name={[name, 'is_sortable']}
															label="Ordenável"
															valuePropName="checked"
															colon={false}
															style={{ marginBottom: 0, width: '100%' }}>
															<Switch size="small" />
														</Form.Item>
													</Col>
												</Row>
											</Space>
										</Card>
									</Col>
								))}
							</Row>
						)}
					</Form.List>
				</Panel>

				<Panel header="Notificação de vencimento de contrados" key="periods">
					<Space
						direction="vertical"
						style={{ width: '100%', marginBottom: 24 }}>
						<Form.Item
							name="notification_emails"
							label="Emails para Notificações"
							rules={[
								{
									type: 'array',
									message: 'Por favor, insira emails válidos',
								},
							]}>
							<Select
								mode="tags"
								placeholder="Digite os emails e pressione Enter"
								style={{ width: '100%' }}
								tokenSeparators={[',', ' ']}
							/>
						</Form.Item>
					</Space>

					<Divider style={{ margin: '24px 0' }} />

					<Form.List name="period_configs">
						{(fields, { add, remove }) => (
							<>
								<Row gutter={[16, 16]}>
									{fields.map(({ key, name, ...restField }) => (
										<Col xs={24} sm={24} md={12} lg={8} xl={6} key={key}>
											<Card
												extra={
													<Button
														type="text"
														danger
														onClick={() => remove(name)}>
														Remover
													</Button>
												}
												bodyStyle={{ padding: '16px' }}>
												<Space direction="vertical" style={{ width: '100%' }}>
													<Form.Item
														{...restField}
														name={[name, 'days_before_end']}
														label="Dias antes do fim"
														rules={[
															{
																required: true,
																message: 'Por favor, insira o número de dias',
															},
														]}
														style={{ width: '100%' }}>
														<InputNumber min={1} style={{ width: '100%' }} />
													</Form.Item>
													<Form.Item
														{...restField}
														name={[name, 'template_ids']}
														label="Modelos de Documento"
														rules={[
															{
																required: true,
																message:
																	'Por favor, selecione pelo menos um modelo',
															},
														]}
														style={{ width: '100%' }}>
														<Select
															mode="multiple"
															placeholder="Selecione os modelos"
															style={{ width: '100%' }}>
															{templates?.map((template) => (
																<Option key={template.id} value={template.id}>
																	{template.name}
																</Option>
															))}
														</Select>
													</Form.Item>
												</Space>
											</Card>
										</Col>
									))}
								</Row>
								<Button
									type="dashed"
									onClick={() => add()}
									block
									style={{ marginTop: 16 }}>
									Adicionar Período
								</Button>
							</>
						)}
					</Form.List>
				</Panel>
			</Collapse>
		</Form>
	)
}

Columns.propTypes = {
	config: PropTypes.shape({
		primary_color: PropTypes.string,
		use_contracts: PropTypes.bool,
		document_columns: PropTypes.arrayOf(
			PropTypes.shape({
				display_name: PropTypes.string,
				name: PropTypes.string,
				sort_name: PropTypes.string,
				is_active: PropTypes.bool,
				is_sortable: PropTypes.bool,
			})
		),
		period_configs: PropTypes.arrayOf(
			PropTypes.shape({
				days_before_end: PropTypes.number,
				template_ids: PropTypes.arrayOf(PropTypes.number),
			})
		),
		notification_emails: PropTypes.arrayOf(PropTypes.string),
	}),
	onSave: PropTypes.func.isRequired,
	templates: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number,
			name: PropTypes.string,
		})
	),
	loadTemplates: PropTypes.func.isRequired,
}

Columns.defaultProps = {
	config: {
		primary_color: '#830AD1',
		use_contracts: false,
		document_columns: [],
		period_configs: [],
		notification_emails: [],
	},
	templates: [],
}

export default connect(
	(state) => ({
		templates: state.template.data,
	}),
	(dispatch) => ({
		loadTemplates: () => dispatch(listTemplate({ perPage: 50 })),
	})
)(Columns)
